export default {
    scorecardApiUrl: 'https://ep-app-scorecard-api-dev-dxa3b6btasetbwff.a01.azurefd.net',
    clientId: '7bf4ee15-d0dc-446b-9e3a-47a4a5c609f1',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5,
    sampleRate: 0
};
